"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[529],{

/***/ 53633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SlotsContext": function() { return /* binding */ SlotsContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* eslint-disable react-hooks/exhaustive-deps */


var SlotsContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});

var SlotsProvider = function SlotsProvider(_ref) {
  var children = _ref.children,
      disableLoadPage = _ref.disableLoadPage,
      _ref$initSlotPageData = _ref.initSlotPageData,
      initSlotPageData = _ref$initSlotPageData === void 0 ? [] : _ref$initSlotPageData;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initSlotPageData),
      slotsPageData = _useState[0],
      setSlotsPageData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([{
    id: '',
    name: 'slotLeft',
    hidden: false
  }]),
      sideBoxTabsList = _useState2[0],
      setSideBoxTabsList = _useState2[1];

  var handleSideBoxTabs = function handleSideBoxTabs(props) {};

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SlotsContext.Provider, {
    value: {
      slotsPageData: slotsPageData,
      sideBoxTabsList: sideBoxTabsList,
      handleSideBoxTabs: handleSideBoxTabs
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (SlotsProvider);

/***/ })

}]);